module.exports = __webpack_public_path__ + "static/img/conveyor-lift-mk-5_256.569284f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conveyor-lift-mk-5_256.png
// module id = THWp
// module chunks = 0